export const getMoveEventName = () => {
  if (window.PointerEvent) return 'pointermove';
  if (window.TouchEvent) return 'touchmove';
  return 'mousemove';
}

export const getUpEventName = () => {
  if (window.PointerEvent) return 'pointerup';
  if (window.TouchEvent) return 'touchend';
  return 'mouseup';
}

export default getMoveEventName;
